import IconCalendar from '../icons/calendar';
import formatDateShort from './format-date-short';
import formatDate from '../../helpers/format-date';
import { DateInputPseudoTypes } from './types';

import styles from './date-input.module.css';

export default function DateInputPseudo({
  title = '',
  datepickerVisible,
  setDatepickerVisible,
  inputValue = '',
  placeholder = '',
  disabled,
  tabIndex,
  focused,
  setFocused,
  withoutHidePlaceholder,
  formatDateLong,
  shortcuts,
  withTime,
  withoutIcon,
}: DateInputPseudoTypes) {
  let buttonContent: string;

  if (!inputValue || withoutHidePlaceholder) {
    buttonContent = placeholder;
  } else {
    buttonContent = formatDateLong
      ? formatDate(inputValue, withTime)
      : formatDateShort(inputValue);
  }

  return (
    <div className={styles.dateInputPseudoWrapper}>
      {title && (
        <div className={styles.dateInputPseudoTitle}>
          {title}
          {shortcuts && <div className={styles.shortcuts}>{shortcuts}</div>}
        </div>
      )}
      <button
        type="button"
        className={`${styles.dateInputPseudo} ${
          (datepickerVisible ? styles.dateInputPseudoDatepickerVisible : '',
          disabled ? styles.disabled : '')
        }`}
        onClick={() => setDatepickerVisible(!datepickerVisible)}
        tabIndex={tabIndex}
        onFocus={() => !focused && setDatepickerVisible(true)}
        onKeyDown={(e) => {
          if (e.key === 'Tab') {
            setDatepickerVisible(false);
            setFocused(false);
          }
        }}
      >
        <div className={styles.dateInputPseudoValue}>{buttonContent}</div>
        {!withoutIcon && <IconCalendar width={17} height={17} />}
      </button>
    </div>
  );
}
